import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import styled, { css } from 'styled-components';
export const inputStyles = css `
  --borderColor: ${brand.white};

  ${ButtonReset}
  width: 100%;
  height: 60px;
  padding: 6px 32px;
  ${fonts.montserrat.regular}
  font-size: 20px;
  color: ${brand.grey.grey16};
  background-color: ${brand.white};
  border: 1px solid var(--borderColor);
  border-radius: 100px;

  &[data-active='true'],
  &:focus {
    --borderColor: ${brand.grey.grey16};
  }

  &:disabled {
    --borderColor: ${brand.grey.grey97};

    opacity: 0.5;
    background-color: ${brand.grey.grey97};
  }

  &.error {
    --borderColor: ${brand.validation.red};
  }

  &::placeholder {
    ${fonts.montserrat.regular}
    font-size: 20px;
    color: inherit;
    opacity: 0.5;
  }
`;
const Input = styled.input `
  ${inputStyles}
`;
export default {
    Input,
};
